
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { MeAviseTipo } from '@app/models/me-avise-tipo.model';

@Injectable()
export class MeAviseTipoService extends ServiceBase {
  constructor(public http: HttpClient) {
    super();
  }

  gravar(meAviseTipo: MeAviseTipo): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/MeAviseTipo', meAviseTipo).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http.delete(this.URL_API + `configuracoes/MeAviseTipo/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/MeAviseTipo/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/MeAviseTipo`);
  }

  obterTodosPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/MeAviseTipo/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
